import {defaultVal, isMeaningful, isMeaningless, toFixed, transformToMap} from "@/utils/common";
import {convertToDate} from "@/utils/date.util";

export function json(obj) {
  return JSON.stringify(obj);
}

export function optionText(id, options, key = 'id', value = 'text') {
  if (!isMeaningful(id)) return null;
  const option = transformToMap(getOption(options), key)[id];
  if (isMeaningful(option)) {
    return option[value];
  }
  return null;
}

export function abs(value) {
  if (!isMeaningful(value)) return null;
  return Math.abs(value);
}

function getOption(options) {
  if (typeof options === 'function') {
    return options();
  } else {
    return options;
  }
}

export function optionColor(id, options, key = 'id') {
  const option = transformToMap(options, key)[id];
  if (isMeaningful(option)) {
    return option;
  }
  return null;
}

export function valConcat(val, obj, prefix, suffix) {
  if (isMeaningful(val)) {
    const _prefix = Object.prototype.hasOwnProperty.call(obj, prefix)
      ? defaultVal(obj[prefix], '') : defaultVal(prefix, '');
    const _suffix = Object.prototype.hasOwnProperty.call(obj, suffix)
      ? obj[suffix] : defaultVal(suffix, '');
    return `${_prefix}${val}${_suffix}`;
  }
  return val;
}

export function defaultShow(val, prefix, suffix, defaultValue = '-') {
  return isMeaningful(val) ? `${defaultVal(prefix, '')}${val}${defaultVal(suffix, '')}` : defaultValue;
}

export function sum(arr, pick) {
  return arr
    .filter(item => !isNaN(item[pick]))
    .map(item => Number(item[pick]))
    .reduce((e1, e2) => e1 + e2, 0);
}

// num：小数位
export function number(val, num = 2) {
  return toFixed(val, num);
}

// 金额(用万、亿简写)  参数：数值、保留几位小数
export function amountSymbol(val, num = 2) {

  if (isMeaningless(val)) {
    return '-';
  }

  if (isNaN(val)) {
    return val;
  }


  //原始值、计算值,数值取小数
  let result = toFixed(Number(val), num);

  // value:计算值字符串（已截取小数点）  origin：原始值字符串，千位用逗号分割（已截取小数点）   originNum：原始数值（已截取小数点）
  let obj = {value: result, unit: '', origin: result, originNum: result};

  if (isMeaningful(result)) {

    // 处理原始值
    const thousandOrigin = amountThousandFormat(result);
    const arrOrigin = thousandOrigin.split('.');

    //用万、亿 简化数值
    if ((result >= 1e4 && result < 1e8) || (result <= -1e4 && result > -1e8)) {
      result = toFixed(Number(result / 1e4), num);
      obj.unit = '万'
    } else if (result > 1e8 || result < -1e8) {
      result = toFixed(Number(result / 1e8), num);
      obj.unit = '亿'
    }
    // 处理简化值
    const thousandResult = amountThousandFormat(result);
    const arr = thousandResult.split('.');

    // 需要精确小数时，才拼接 '.0*n'
    if(num>0){
      //取原始值
      if (arrOrigin.length === 2) {
        obj.origin = arrOrigin[1].length >= 2 ? thousandOrigin : thousandOrigin + '0';
      } else {
        obj.origin = thousandOrigin + '.00';
      }

      //取简化值
      if (arr.length === 2) {
        obj.value = arr[1].length >= 2 ? thousandResult : thousandResult + '0';
        // return {value:arr[1].length >= 2 ? thousandResult : thousandResult + '0', unit:unit}
      } else {
        obj.value = thousandResult + '.00';
        // return {value:thousandResult + '.00', unit:unit}
      }
    }
    // 不需要精确小数时，直接返回
    else {
      obj.origin = thousandOrigin
      obj.value = thousandResult
    }
    return obj;
  }
  return obj;
}

// 金额  参数：数值、保留几位小数
export function amount(val, num = 2) {
  if (isNaN(val)) {
    return val;
  }

  if (isMeaningless(val)) {
    return val;
  }
  let result = toFixed(Number(val), num);
  if (isMeaningful(result)) {
    const thousandResult = amountThousandFormat(result);
    const arr = thousandResult.split('.');
    if (arr.length === 2) {
      return arr[1].length >= 2 ? thousandResult : thousandResult + '0';
    } else {
      return thousandResult + '.00'
    }
  }
  return result;
}

function amountThousandFormat(num) {
  return num.toString().replace(/\d+/, (n) => {
    return n.replace(/(\d)(?=(\d{3})+$)/g, $1 => $1 + ",");
  });
}


export function formatToDate(val, defaultValue = '-') {
  if (!val) { return defaultValue }
  return convertToDate(new Date(val)) || defaultValue;
}


